import { Button, Snackbar, createTheme } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AppContent from './components/main/AppContent';
import ErrorBoundary from './components/common/ErrorBoundary';
import { store } from './reducers';


const theme = createTheme({
    palette: {
        primary: {
            main: '#3D7A96',
        },
        secondary: {
            main: '#f44336',
        },
        error: {
            main: '#e73e33',
        },
    },
});


class App extends React.Component {

    updateCheckIntervalId = null;
    updateReloadTimeoutId = null;

    state = {
        showUpdateToast: false,
        updateReloadScheduled: false,
    };

    getCurrentMainBundlePath() {
        const scripts = Array.from(document.getElementsByTagName('script'));
        const mainScript = scripts.find(script => script.src && script.src.includes('/static/js/main.'));
        return mainScript ? mainScript.src : null;
    }

    async checkForNewBuild() {
        if (process.env.NODE_ENV !== 'production') {
            return;
        }

        const currentMainBundlePath = this.getCurrentMainBundlePath();
        if (!currentMainBundlePath) {
            return;
        }

        try {
            const response = await fetch(`/asset-manifest.json?t=${Date.now()}`, {
                cache: 'no-store',
                headers: {
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache',
                },
            });

            if (!response.ok) {
                return;
            }

            const manifest = await response.json();
            const latestMainBundlePath = manifest && manifest.files ? manifest.files['main.js'] : null;

            if (!latestMainBundlePath) {
                return;
            }

            const normalizedCurrent = currentMainBundlePath.split('?')[0];
            if (!normalizedCurrent.endsWith(latestMainBundlePath)) {
                this.scheduleReloadForNewBuild();
            }
        } catch (error) {
            // Ignore transient network/cache errors and retry on next interval.
        }
    }

    scheduleReloadForNewBuild() {
        if (this.state.updateReloadScheduled) {
            return;
        }

        this.setState({ showUpdateToast: true, updateReloadScheduled: true });
        this.updateReloadTimeoutId = window.setTimeout(() => {
            window.location.reload();
        }, 3500);
    }

    reloadNow = () => {
        window.location.reload();
    }

    startBuildVersionWatcher() {
        if (this.updateCheckIntervalId) {
            return;
        }

        this.updateCheckIntervalId = window.setInterval(() => {
            this.checkForNewBuild();
        }, 60000);

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    stopBuildVersionWatcher() {
        if (this.updateCheckIntervalId) {
            window.clearInterval(this.updateCheckIntervalId);
            this.updateCheckIntervalId = null;
        }

        if (this.updateReloadTimeoutId) {
            window.clearTimeout(this.updateReloadTimeoutId);
            this.updateReloadTimeoutId = null;
        }

        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            this.checkForNewBuild();
        }
    }

    getFaviconEl() {
        return document.getElementById("favicon");
    }

    componentDidMount()
    {
       const location = window.location.origin;

       if(location.includes("dev") || location.includes("staging"))
       {
           this.getFaviconEl().href = `${location}/devStagingfavicon.ico`
       }

       this.startBuildVersionWatcher();
       this.checkForNewBuild();

    }

    componentWillUnmount() {
        this.stopBuildVersionWatcher();
    }
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter >
                    <MuiThemeProvider theme={theme}>
                        <ErrorBoundary>
                            <AppContent />
                        </ErrorBoundary>
                        <Snackbar
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            open={this.state.showUpdateToast}
                            message="A new version is available. Refreshing now..."
                            action={
                                <Button color="secondary" size="small" onClick={this.reloadNow}>
                                        Refresh now
                                    </Button>
                                }
                            />
                        {/* </AppInfoContext.Provider>                     */}
                    </MuiThemeProvider>
                </BrowserRouter>
            </Provider>


        );
    }
}

export default App;